import styled from 'styled-components';
import {dFlexCenter, LIGHT_GRAY, TURQUISE_BLUE, mobileMedia} from '../../../../../globalVariables/GlobalVariables';
import {dFlex, flexColumn, alignCenter, alignStart} from '../../../../../globalVariables/GlobalFlex';

export const committeesSection = styled.div`
    padding: 20px;
    background-color: ${LIGHT_GRAY};
    border-radius: 8px;
     ${dFlex}
    ${flexColumn}
    gap: 15px;
`;

export const committeesTitle = styled.h3`
    font-size: 11px;
    font-weight: normal;
    letter-spacing: 1.2px;
    margin-block-end: 20px;
`;

export const committeeRow = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: 10px;
    
    ${mobileMedia} {
        ${flexColumn}
        gap: 0px;
        ${alignStart}
    }
`;

export const committeeNameSection = styled.div`
    flex: 1;
    min-width: 300px;
`;


export const addCommitteeButton = styled.div`
    ${dFlex}
    ${alignCenter}
    font-size: 16px;
    gap: 10px;
`;

export const addIcon = styled.div`
    font-size: 18px;
    font-weight: bold;
    background-color: ${TURQUISE_BLUE};
    cursor: pointer;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    ${dFlexCenter}
`;

export const container = styled.div`
    ${dFlex}
    ${flexColumn}
    gap: 10px;
`;

export const wrapText = styled.div`
    font-size: 14px;
    font-weight: 500;
`;

export const values = styled.div`
    font-size: 14px;
    font-weight: 500;
`;

export const plus = styled.div`
    font-size: 18px;
    font-weight: bold;
    background-color: ${TURQUISE_BLUE};
    cursor: pointer;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    ${dFlexCenter}
`;
